import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  ElementRef,
  OnChanges,
  SimpleChanges,
  input,
  viewChild,
  output
} from "@angular/core";

@Component({
  selector: "av-confirm",
  templateUrl: "./confirm.component.html",
  styleUrls: ["./confirm.component.scss"],
  standalone: false,
})
export class ConfirmComponent implements OnInit, OnChanges {
  @Input()
  set open(value: boolean) {
    this._open = value;
    // Initial focus setting if the component loads and is already set to open
    if (this.open) {
      this.setFocusOnConfirm();
    }
  }

  get open(): boolean {
    return this._open;
  }

  readonly arrow = input<"top-left" | "top-right" | "bottom-left" | "bottom-right">("top-left");

  readonly cancelLabel = input<string>(undefined);

  readonly canConfirm = input<boolean>(true);

  readonly confirmed = output<void>();
  readonly canceled = output<void>();

  readonly confirmRef = viewChild("confirmRef", { read: ElementRef });

  readonly cancelRef = viewChild("cancelRef", { read: ElementRef });

  hAlign: string;
  vAlign: string;
  _open = false;

  constructor() {}

  ngOnInit(): void {
    this.hAlign = this.arrow().split("-")?.[1] || "left";
    this.vAlign = this.arrow().split("-")?.[0] === "bottom" ? "top" : "bottom";
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["open"] && changes["open"].currentValue === true) {
      this.setFocusOnConfirm();
    }
  }

  private setFocusOnConfirm(): void {
    requestAnimationFrame(() => this.confirmRef()?.nativeElement?.focus());
  }

  // get hAlign() {
  //   return  // === "top-left" ? "left" : "right";
  // }
  // get vAlign() {
  //   return this.arrow.split("-")?.[1] || "top";
  // }

  cancel() {
    this.canceled.emit();
  }

  confirm() {
    this.confirmed.emit();
  }
}
